import { Typography } from '@mui/material';
import React from 'react';

const Pay = () => {
    return (
        <div>
            <Typography variant="h5">
                Payment system comming soon...
            </Typography>
        </div>
    );
};

export default Pay;